var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h4 class=\"repair-item-title\">{{ item.name }}</h4><p>{{ item.description }}</p><h5 ng-if=\"item.opendoor_list\">Opendoor will cover:</h5><ul ng-if=\"item.opendoor_list\"><li ng-repeat=\"detail in item.opendoor_list\">{{ detail }}</li></ul><h5 ng-if=\"item.repair_credit_list\">Repair credits will cover:</h5><ul ng-if=\"item.repair_credit_list\"><li ng-repeat=\"detail in item.repair_credit_list\">{{ detail }}</li></ul>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-repair-item.jade
 ** module id = 3512
 ** module chunks = 3
 **/